export default "__VITE_ASSET__CeS58w25__"